import { render, staticRenderFns } from "./supplementInfo.vue?vue&type=template&id=8fcd3b92&scoped=true"
import script from "./supplementInfo.vue?vue&type=script&lang=ts"
export * from "./supplementInfo.vue?vue&type=script&lang=ts"
import style0 from "./supplementInfo.vue?vue&type=style&index=0&id=8fcd3b92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd3b92",
  null
  
)

export default component.exports